import { render } from "./BlogContent.vue?vue&type=template&id=09b2e4e9&ts=true"
import script from "./BlogContent.vue?vue&type=script&lang=ts"
export * from "./BlogContent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__